// extracted by mini-css-extract-plugin
export default {"noImage":"NFTMedia_noImage__zGlqn","imageContainer":"NFTMedia_imageContainer__MejTQ","image":"NFTMedia_image__pHYgW"};